var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 74,
    viewBox: "0 0 77 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4999 71.5C57.8602 71.5 73.6399 56.1003 73.6399 37C73.6399 17.8997 57.8602 2.5 38.4999 2.5C19.1395 2.5 3.35986 17.8997 3.35986 37C3.35986 56.1003 19.1395 71.5 38.4999 71.5Z",
    fill: "#F0998D",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9174 17.522V23.9517C32.9174 23.9517 27.8764 24.3327 27.9573 28.8685C27.895 30.0562 28.2931 31.223 29.0716 32.1349C29.8502 33.0468 30.9517 33.6364 32.1551 33.7854H44.3642C44.3642 33.7854 55.2062 33.9419 55.0494 45.8891C54.917 55.7656 43.5976 56.4785 43.5976 56.4785V50.0488C43.5976 50.0488 48.3988 49.665 48.5577 45.5109C48.6315 44.8345 48.5574 44.1504 48.3403 43.5043C48.1233 42.8581 47.7683 42.2648 47.2989 41.7638C46.8296 41.2627 46.2567 40.8655 45.6185 40.5986C44.9803 40.3317 44.2913 40.2012 43.5976 40.2158H31.7729C31.7729 40.2158 21.3768 39.2832 21.4699 28.8685C21.5615 18.6517 31.0314 17.5423 32.9174 17.522Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logoMini.c2966cc9bb569208afa16df95de95627.svg";
export { ForwardRef as ReactComponent };